/**
 * This is the base class for all pages in the Business Hub application. It contains a title that
 * will show at the top left of the page
 */
import { Component, OnInit } from '@angular/core';

@Component({
    template: '',
    standalone: false
})
export abstract class BasePageComponent implements OnInit {
  public title: string;

  constructor() { }

  ngOnInit(): void {
    this.title = 'Default Title';
  }

  // Add any other common methods here
}
